import React, { useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import Milage from "../../images/mileage.png";
import Automatic from "../../images/automatic.png";
import Manual from "../../images/manual.png";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import axios from "axios";
import {
  faGasPump,
  faCalendar,
  faLocationDot,
  faGaugeHigh,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AuthContext } from "../../context/AuthContext";
import { baseUrl, awsImageURL } from "../../api/ipconfig";

const AddBikeCard = ({ ad }) => {
  const { user } = React.useContext(AuthContext);

  const [open, setOpen] = useState(false);
  const [statusMsg, setStatusMsg] = useState("");
  const [data, setData] = useState([]);

  const formatPrice = (price) => {
    if (price >= 100000000000) {
      return (
        (price / 100000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Kharab"
      );
    } else if (price >= 1000000000) {
      return (
        (price / 1000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Arab"
      );
    } else if (price >= 10000000) {
      return (
        (price / 10000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Crore"
      );
    } else if (price >= 100000) {
      return (
        (price / 100000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " lacs"
      );
    } else if (price >= 1000) {
      return (
        (price / 1000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " Thousand"
      );
    } else {
      return price.toLocaleString("en-US", { maximumFractionDigits: 2 });
    }
  };

  const calculateDaysAgo = (dateString) => {
    const givenDate = moment.tz(dateString, "YYYY-MM-DDTHH:mm:ss.SSSZ", "UTC");
    const currentDate = moment();
    const daysAgo = currentDate.diff(givenDate, "days");

    if (daysAgo === 0) {
      return "Today";
    } else if (daysAgo < 30) {
      return `${daysAgo} Day${daysAgo > 1 ? "s" : ""} ago`;
    } else if (daysAgo < 365) {
      const months = Math.floor(daysAgo / 30);
      return `${months} Month${months > 1 ? "s" : ""} ago`;
    } else {
      const years = Math.floor(daysAgo / 365);
      return `${years} Year${years > 1 ? "s" : ""} ago`;
    }
  };

  const openWhatsApp = () => {
    const whatsappUrl = `http://api.whatsapp.com/send?phone=${
      ad?.phone
    }&text=${encodeURIComponent("Hi")}`;
    window.open(whatsappUrl, "_blank");
  };

  const addToWishlist = async (post_id) => {
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();

      formData.append("post_id", post_id);
      formData.append("Id", user?.id);
      await axios.post(`${baseUrl}/fame/addToWishlist`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const response = await axios.get(`${baseUrl}/posts/condition`, {
        params: {
          condition: "used",
        },
      });
      const updatedWishlistData = response?.data?.data;

      setData(updatedWishlistData);

      setStatusMsg("Added to saved ads");
      setOpen(true);
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  const removeFromWishlist = async (post_id) => {
    try {
      const token = localStorage.getItem("token");

      await axios.delete(`${baseUrl}/fame/deletewishlist`, {
        params: {
          userId: user?.id,
          post_id: post_id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const response = await axios.get(`${baseUrl}/posts/condition`, {
        params: {
          condition: "used",
        },
      });
      const updatedWishlistData = response?.data?.data;

      setData(updatedWishlistData);

      setStatusMsg("Remove from saved ads");
      setOpen(true);
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  const initiateCall = (event, phoneNumber) => {
    event.stopPropagation();
    event.preventDefault();
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <>
      <div className="row ">
        <div className=" ">
          <div className="myAd p-3 mb-3">
            <Link to={`/bike-details/${ad?.post_id}`} className="row">
              <div
                className="col-lg-3 Myads_photos cursorPointer"
                key={ad?.post_id}
              >
                <div className="position-relative">
                  <img
                    src={`${awsImageURL}/bike_post/${ad?.post_token}/${ad?.cover}`}
                    alt={`${ad?.bikemake_name} ${ad?.modelName} ${ad?.yearName}`}
                    srcSet=""
                    key={ad.post_id}
                    onError={(e) => {
                      e.target.src =
                        "https://gallery.famewheels.com/appgallery/no-image.png";
                    }}
                  />
                  <div className="d-flex align-items-center justify-content-between position-absolute top-0 w-100 ">
                    {ad?.post_type_id === 2 && (
                      <div className="right_ribbon ">Featured</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-7 ps-lg-0">
                <div className="vehicleDetails  text-capitalize">
                  <h4 key={ad.post_id} className="fw-500 cursorPointer ">
                    {ad?.bikemake_name} {ad?.bikemodel_name} {ad?.year_name}
                  </h4>
                  <p className=" text-secondary  small text-truncate-custom">
                    {ad?.description}
                  </p>

                  <style jsx>{`
                .text-truncate-custom {
                  display: -webkit-box;
                  -webkit-line-clamp: 2; /* Limit to 3 lines */
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                
                
              `}</style>

                  <div className="d-flex justify-content-between pr-3 d-md-none">
                    <h5 className="fw-600 priceClass color-secondary">
                      {ad.price > 0
                        ? `PKR: ${formatPrice(ad.price)}`
                        : "Call for price"}
                    </h5>

                    <p
                      style={{ color: "#212121", fontSize: 14 }}
                      className=" m-0"
                    >
                      {calculateDaysAgo(ad?.year_name)}
                    </p>
                  </div>
                  <h5 className="fw-600 priceClass d-none d-md-block color-secondary">
                    {ad.price > 0
                      ? `PKR: ${formatPrice(ad.price)}`
                      : "Call for price"}
                  </h5>

                  <div className="d-flex justify-content-start align-items-center mt-3 mt-md-0 text-center flex-wrap">
                    <div className="text-center">
                      <div className="d-flex align-items-center text-black  rounded-3 me-3 mb-0">
                        <FontAwesomeIcon
                          className="me-2"
                          icon={faLocationDot}
                        />
                        <span className="small">{ad?.city}</span>
                      </div>
                      <div className="d-flex align-items-center text-black  mt-2 rounded-3 me-3 mb-0">
                        <img
                          className="vehicledDetail_icon me-2"
                          src={Milage}
                          alt=""
                        />
                        <span className="small">{ad?.mileage} Km</span>
                      </div>
                    </div>

                    <div>
                      <div className="d-flex align-items-center text-black rounded-3 me-3 mb-0">
                        <FontAwesomeIcon className="me-2" icon={faGaugeHigh} />
                        <span className="small text-lowercase">
                          {ad?.engine_type}
                        </span>
                      </div>

                      <div className="d-flex align-items-center text-black rounded-3 me-3 mb-0">
                        <FontAwesomeIcon className="me-2" icon={faCalendar} />
                        <span className="small">{ad?.year_name}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {ad?.wish === 0 ? (
                <div
                  onClick={() => addToWishlist(ad?.post_id)}
                  className="ms-auto ad-share-btns position-relative"
                >
                  <Tooltip
                    title="Save this Ad"
                    arrow
                    placement="top"
                    TransitionComponent={Zoom}
                    enterDelay={40}
                    leaveDelay={200}
                  >
                    <button className="btn boxShadow">
                      <i className="fa-regular fa-heart"></i>
                    </button>
                  </Tooltip>
                </div>
              ) : ad?.wish === 1 ? (
                <div
                  onClick={() => removeFromWishlist(ad?.post_id)}
                  className="ms-auto ad-share-btns position-relative"
                >
                  <Tooltip
                    title="Added to Saved Ads"
                    arrow
                    placement="top"
                    TransitionComponent={Zoom}
                    enterDelay={40}
                    leaveDelay={200}
                  >
                    <div className="ms-auto ad-share-btns">
                      <button className="btn boxShadow">
                        <i className="fa-solid fa-heart"></i>
                      </button>
                    </div>
                  </Tooltip>
                </div>
              ) : null}
              {/* <div className="col-2 d-md-none d-block ">
                <p>detail</p>
              </div> */}
              <div className=" col-lg-2  mt-3 mt-md-none  col-12 mt-2 d-md-flex d-block align-items-end flex-column justify-content-between  text-center ">
                <p
                  style={{ color: "#212121", fontSize: 14 }}
                  className="d-none d-md-block m-0"
                >
                  {calculateDaysAgo(ad?.year_name)}
                </p>
                <div className="d-flex gap-4 d-md-block">
                  <button
                    className="btn w-100  btnFont bgSecondary mb-md-2 mb-0 text-white  "
                    type="button"
                    onClick={(event) => initiateCall(event, ad?.phone)}
                  >
                    <i className="fa-solid fa-phone me-2"></i>
                    Call
                  </button>

                  <button
                    onClick={openWhatsApp}
                    type="button"
                    className="btn w-100 bg-success text-white btnFont"
                  >
                    <i className="fab fa-whatsapp"></i> Whatsapp
                  </button>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBikeCard;
